import React from 'react';
import s from './TermsOfUse.module.css';

const TermsOfService: React.FC = () => {
    return (
        <div className={s.terms_of_service}>
            <h1>Terms of Service</h1>
            <p><strong>Last Updated: November 28th, 2024</strong></p>

            <h2>Introduction</h2>
            <p>
                These terms of use (the “Terms”) are a legal agreement between you (“you”, “your”) and AIOHub Inc.,
                including
                our parents, subsidiaries and affiliates (“AIO”, “we” or “us”) governing your use of our services,
                including the
                website at simpleecreate.com mobile applications and other products and services (collectively, the
                “Service”).
                By agreeing to these Terms or by using our Service, you agree to be bound by these Terms, as they are
                amended
                from time to time, and the documents referred to in them. If you do not agree with or accept any of
                these Terms,
                you should cease using the Service immediately.
            </p>
            <p>
                By using the Service or by clicking to accept these Terms, you accept and agree to be bound and comply
                with
                these Terms and our privacy policy (the “Privacy Policy”), found at www.simpleecreate.com, which is
                incorporated
                herein by reference. If you do not agree to these Terms or the privacy policy, you must not access or
                use the Service.
            </p>

            <h2>Modifications to the Terms</h2>
            <ul>
                <li>
                    We reserve the right in our sole discretion to revise and update these Terms from time to time. Any
                    and all
                    such modifications are effective immediately upon posting and apply to all access to and continued
                    use of the
                    Service. You agree to periodically review these Terms in order to be aware of any such modifications
                    and your
                    continued use shall be your acceptance of these.
                </li>
                <li>
                    The information and content on the Service may be changed, withdrawn or terminated at any time in
                    our sole
                    discretion without notice. We will not be liable if, for any reason, all or any part of the Service
                    is restricted
                    to users or unavailable at any time or for any period.
                </li>
            </ul>

            <h2>Your Use of the Service and Security</h2>
            <ul>
                <li>
                    The security of your personal information is very important to us. We use physical, electronic, and
                    administrative measures designed to secure your personal information from accidental loss and from
                    unauthorized
                    access, use, alteration, and disclosure.
                </li>
                <li>
                    Unfortunately, the transmission of information via the Internet is not completely secure. Although
                    we do our best
                    to protect your personal information, we cannot guarantee the security of your personal information
                    transmitted
                    to our Service. Any transmission of personal information is at your own risk. We are not responsible
                    for
                    circumvention of any privacy settings or security measures contained on the Service.
                </li>
                <li>
                    Any username, password, or any other piece of information chosen by you, or provided to you as part
                    of our
                    security procedures, must be treated as confidential, and you must not disclose it to any other
                    person or entity.
                    You must exercise caution when accessing your account from a public or shared computer so that
                    others are not
                    able to view or record your password or other personal information. You understand and agree that
                    should you be
                    provided an account, your account is personal to you and you agree not to provide any other person
                    with access to
                    this Service or portions of it using your username, password, or other security information. You
                    agree to notify
                    us immediately of any unauthorized access to or use of your username or password or any other breach
                    of security.
                    You also agree to ensure that you logout from your account at the end of each session. You are
                    responsible for any
                    password misuse or any unauthorized access.
                </li>
                <li>
                    You are prohibited from attempting to circumvent and from violating the security of the Service,
                    including,
                    without limitation:
                    <ul>
                        <li>(a) accessing content and data that is not intended for you;</li>
                        <li>(b) attempting to breach or breaching the security and/or authentication measures which are
                            not authorized;
                        </li>
                        <li>(c) restricting, disrupting or disabling service to users, hosts, servers or networks;</li>
                        <li>(d) illicitly reproducing TCP/IP packet header;</li>
                        <li>(e) disrupting network services and otherwise disrupting our ability to monitor the
                            Service;
                        </li>
                        <li>(f) using any robot, spider, or other automatic device, process, or means to access the
                            Service for any
                            purpose, including monitoring or copying any of the content on the Service;
                        </li>
                        <li>(g) introducing any viruses, trojan horses, worms, logic bombs, or other content that is
                            malicious or
                            technologically harmful;
                        </li>
                        <li>(h) attacking the Service via a denial-of-service attack, distributed denial-of-service
                            attack, flooding,
                            mailbombing or crashing; and
                        </li>
                        <li>(i) otherwise attempting to interfere with the proper working of the Service.</li>
                    </ul>
                </li>
                <li>
                    We reserve the right at any time and from time to time, to disable or terminate your account,
                    subscription
                    (as defined below), any username, password, or other identifier, whether chosen by you or provided
                    by us, in
                    our sole discretion for any or no reason, including any violation of any provision of these Terms.
                </li>
            </ul>

            <h2>Payment</h2>
            <ul>
                <li>
                    If you subscribe for paid services offered by us (a “subscription”), you agree to pay us the
                    applicable fees
                    and taxes. Your subscription will automatically renew monthly unless your subscription is cancelled
                    in accordance
                    with these Terms.
                </li>
                <li>
                    The credit card which you provide to us or our third party payment provider will be charged for your
                    subscription
                    on the first day of each monthly billing cycle (the same day of the month that you originally signed
                    up for a
                    subscription). All fees and other charges are final and non-refundable.
                </li>
                <li>
                    You may cancel your subscription at any time. If you do cancel your subscription, it will be
                    effective at the end
                    of the current monthly billing cycle. You will not receive a refund for any fees paid in respect of
                    your final month.
                    You will continue to have access to your subscription for the duration of that monthly billing
                    cycle.
                </li>
                <li>
                    All prices are subject to change upon notice. Such notice may be provided by email to you or in the
                    form of an
                    announcement on the Service.
                </li>
            </ul>

            <h2>Intellectual Property Rights and Ownership</h2>
            <ul>
                <li>
                    The “content” on the Service includes all video, audio, graphics, photographs, information, text,
                    software,
                    code, interactive features, metrics and other materials.
                </li>
                <li>
                    You understand and agree that the Service and its content, features, and functionality, including,
                    but not
                    limited to, displays, design, presentation, selection, and arrangement, are owned by AIO, its
                    licensors, or
                    other providers of such content and are protected in all forms by intellectual property laws
                    including without
                    limitation, copyright, trademark, patent, trade secret, and any other proprietary rights.
                </li>
                <li>
                    The AIO name, logo and all related names, logos, product and service names, designs, images and
                    slogans are
                    our trademarks. You must not use such marks without our prior written permission. Other names,
                    logos, product
                    and service names, designs, images and slogans mentioned, or which appear on the Service are the
                    trademarks
                    of their respective owners. Use of any such property, except as expressly authorized, shall
                    constitute an
                    infringement or violation of the rights of the property owner and may be a violation of federal or
                    other laws
                    and could subject the infringer to legal action.
                </li>
                <li>
                    You shall not directly or indirectly reproduce, compile for an internal database, distribute,
                    modify, create
                    derivative works of, publicly display, publicly perform, republish, download, store, or transmit any
                    of the
                    content on our Service, in any form or medium whatsoever except as may be permitted as a feature of
                    the Service.
                </li>
                <li>
                    Users are not permitted to modify copies of any content from the Service nor delete or alter any
                    copyright,
                    trademark, or other proprietary rights notices from copies of content from the Service.
                </li>
                <li>
                    Except as provided in these Terms, you have no right, title, or interest in or to the Service or to
                    any content
                    on the Service, and all rights not expressly granted are reserved by us. Any use of the Service not
                    expressly
                    permitted by these Terms is a breach of these Terms and may infringe or violate copyright,
                    trademark, and other
                    intellectual property or other proprietary laws.
                </li>
            </ul>
            <h2>Conditions of Use and Content Standards</h2>
            <ul>
                <li>
                    As a condition of your access and use, you agree that you may use the Service only for lawful
                    purposes and
                    in accordance with these Terms.
                </li>
                <li>
                    The content standards in the following paragraph (the “Content Standards”) apply to any and all
                    content a
                    user submits, posts, publishes, displays, or transmits (collectively, "submit") to the Service, to
                    other users
                    or other persons (collectively, "User Content") and any and all interactive functions. Any and all
                    User
                    Content must comply with all applicable laws and these Terms.
                </li>
                <li>
                    Without limiting the foregoing, you warrant and agree that your use of the Service and any User
                    Content shall not:
                    <ul>
                        <li>
                            In any manner violate any applicable federal, provincial, local, or international law or
                            regulation
                            including, without limitation, any laws regarding the export of data or software, patent,
                            trademark,
                            trade secret, copyright, or other intellectual property, legal rights (including the rights
                            of
                            publicity and privacy of others) or contain any content that could give rise to any civil or
                            criminal
                            liability under applicable laws or regulations or that otherwise may be in conflict with
                            these Terms
                            and our Privacy Policy.
                        </li>
                        <li>
                            In any manner violate the terms of use of any third-party website that is linked to the
                            Service,
                            including but not limited to, any third-party social media website.
                        </li>
                        <li>
                            Include or contain any content that is exploitive, obscene, harmful, threatening, abusive,
                            harassing,
                            hateful, defamatory, sexually explicit or pornographic, violent, inflammatory, or
                            discriminatory based
                            on race, sex, religion, nationality, disability, sexual orientation, or age or other such
                            legally
                            prohibited ground or be otherwise objectionable, such determination to be made in AIOHub’s
                            sole
                            discretion.
                        </li>
                        <li>
                            Involve stalking, attempting to exploit or harm any individual (including minors) in any way
                            by
                            exposing them to inappropriate content or otherwise or ask for personal information as
                            prohibited
                            under applicable laws.
                        </li>
                        <li>
                            Involve, provide or contribute any false, inaccurate or misleading information.
                        </li>
                        <li>
                            Include sending, knowingly receiving, uploading, downloading, using, or reusing any content
                            that does
                            not comply with the User Content and Content Standards set out in these Terms.
                        </li>
                        <li>
                            Impersonate or attempt to impersonate AIOHub, a AIOHub employee, another user, or any other
                            person or
                            entity (including, without limitation, by using email addresses, or screen names associated
                            with any
                            of the foregoing).
                        </li>
                        <li>
                            Transmit, or procure the sending of, any advertisements or promotions, other than those
                            expressly
                            permitted by the Service, without our prior written consent, sales, or encourage any other
                            commercial
                            activities, including, without limitation, any "spam", "junk mail", "chain letter",
                            contests,
                            sweepstakes and other sales promotions, barter, or advertising or any other similar
                            solicitation.
                        </li>
                        <li>
                            Encourage any other conduct that restricts or inhibits anyone's use or enjoyment of the
                            Service, or
                            which, as determined by us, may harm AIO or users of the Service or expose them to
                            liability.
                        </li>
                        <li>
                            Cause annoyance, inconvenience, or needless anxiety or be likely to upset, embarrass, or
                            alarm any
                            other person.
                        </li>
                        <li>
                            Promote any illegal activity, or advocate, promote, or assist any unlawful act.
                        </li>
                        <li>
                            Give the impression that they originate from or are endorsed by us or any other person or
                            entity, if
                            this is not the case.
                        </li>
                    </ul>
                </li>
                <li>User Content - Grant of Licence</li>
                <ul>
                    <li>
                        The Service contains interactive functions which allow User Content on or through the Service.
                    </li>
                    <li>
                        None of the User Content you submit to the Service will be subject to any confidentiality by
                        AIOHub. By
                        providing any User Content to the Service, you grant us and our service providers, and each of
                        their and
                        our respective licensees, successors, and assigns the right to a world-wide, royalty free,
                        perpetual,
                        irrevocable, non-exclusive license to use, reproduce, modify, perform, display, distribute, and
                        otherwise
                        disclose to third parties any such content for any purpose and according to your account
                        settings and/or
                        incorporate such content into any form, medium or technology throughout the world without
                        compensation
                        to you. You further waive any moral rights or other rights of authorship as a condition of
                        submitting
                        any User Content.
                    </li>
                    <li>
                        By providing any User Content to the Service, you also grant other users of the Service the
                        right to a
                        world-wide, royalty free, non-exclusive license to use, reproduce, modify, perform, display,
                        distribute,
                        and otherwise disclose to third parties any such content for any purpose as may be permitted as
                        a feature
                        of the Service.
                    </li>
                    <li>
                        By submitting the User Content, you declare and warrant that you own or have the necessary
                        rights to submit
                        the User Content and have the right to grant the license hereof to us and our service providers,
                        and each
                        of their and our respective licensees, successors, and assigns to the User Content and comply
                        with these
                        Terms. You represent and warrant that all User Content complies with applicable laws and
                        regulations and
                        the User Content and Content Standards set out in these Terms.
                    </li>
                    <li>
                        You understand and agree that you (not the AIO or its respective directors, officers, employees,
                        agents,
                        service providers, contractors, licensors, suppliers or successors) are fully responsible for
                        any User
                        Content you submit or contribute, and you are fully responsible and legally liable, including to
                        any third
                        party, for such content and its accuracy. We are not responsible or legally liable to any third
                        party for
                        the content or accuracy of any User Content submitted by you or any other user of the Service.
                    </li>
                </ul>
                <li>Site Monitoring and Enforcement, Suspension and Termination</li>
                <ul>
                    <li>
                        AIOHub has the right, but not the obligation, without provision of notice to:
                        <ul>
                            <li>Remove or refuse to post on the Service any User Content for any or no reason in our
                                sole discretion.
                            </li>
                            <li>
                                At all times, take such actions with respect to any User Content deemed necessary or
                                appropriate in
                                our sole discretion, including, without limitation, for violating the Service and User
                                Content and
                                Content Standards or Terms.
                            </li>
                            <li>
                                Take appropriate legal action, including, without limitation, referral to law
                                enforcement or
                                regulatory authority, or notifying the harmed party of any illegal or unauthorized use
                                of the Service.
                                Without limiting the foregoing, we have the right to fully cooperate with any law
                                enforcement
                                authorities or court order requesting or directing us to disclose the identity or other
                                information
                                of anyone posting any content on or through the Service.
                            </li>
                            <li>
                                Terminate or suspend your access to all or part of the Service for any or no reason,
                                including,
                                without limitation, any violation of these Terms.
                            </li>
                        </ul>
                    </li>
                    <li>
                        YOU WAIVE AND HOLD AIOHUB HARMLESS AND ITS RESPECTIVE DIRECTORS, OFFICERS, EMPLOYEES, AGENTS,
                        SERVICE
                        PROVIDERS, CONTRACTORS, LICENSORS, LICENSEES, SUPPLIERS AND SUCCESSORS FROM ANY AND ALL CLAIMS
                        RESULTING
                        FROM ANY ACTION TAKEN BY US AND ANY OF THE FOREGOING PARTIES RELATING TO ANY, INVESTIGATIONS BY
                        EITHER
                        AIO OR SUCH PARTIES OR BY LAW ENFORCEMENT AUTHORITIES.
                    </li>
                    <li>
                        We have no obligation, nor any responsibility to any party to monitor the Service or its use,
                        and do not and
                        cannot undertake to review content that you or other users submit to the Service. We cannot
                        ensure prompt
                        removal of objectionable content after it has been posted and we have no liability for any
                        action or inaction
                        regarding transmissions, communications, or content provided by any user or third party, subject
                        to applicable laws.
                    </li>
                </ul>

                <li>No Reliance</li>
                <ul>
                    <li>
                        The content on our Service is provided for general information purposes only. It is not intended
                        to amount
                        to advice on which you should rely. You must obtain more specific or professional advice before
                        taking, or
                        refraining from, any action or inaction on the basis of the content on our site.
                    </li>
                    <li>
                        Although we make reasonable efforts to update the information on our Service, we make no
                        representations,
                        warranties or guarantees, whether express or implied, that the content on our Service is
                        accurate, complete
                        or up to date. Your use of the Service is at your own risk and neither AIO nor its respective
                        directors,
                        officers, employees, agents, service providers, contractors, licensors, licensees, suppliers or
                        successors
                        have any responsibility or liability whatsoever for your use of this Service.
                    </li>
                    <li>
                        This Service includes content provided by third parties, including from other users and
                        third-party licensors.
                        All statements and/or opinions expressed in any such third-party content, other than the content
                        provided by
                        AIOHub, are solely the opinions and the responsibility of the person or entity providing such
                        content. Such
                        content does not necessarily reflect the opinion of AIOHub. Neither AIOHub nor our directors,
                        officers,
                        employees, agents, service providers, contractors, licensors, licensees, suppliers or successors
                        have any
                        responsibility or liability whatsoever to you, or any third party, for the content or accuracy
                        of any
                        third-party content.
                    </li>
                </ul>

                <li>Third Party Websites</li>
                <ul>
                    <li>
                        For your convenience, this Service may provide links or pointers to third-party websites. We
                        make no
                        representations about any other websites that may be accessed from this Service. If you choose
                        to access any
                        such websites, you do so at your own risk. We have no control over the contents of any such
                        third-party
                        websites and accept no responsibility for such websites or for any loss or damage that may arise
                        from your
                        use of them. You are subject to any Terms of such third-party websites.
                    </li>
                </ul>

                <li>Disclaimer of Warranties</li>
                <ul>
                    <li>
                        YOU UNDERSTAND AND AGREE THAT YOUR USE OF THE SERVICE, ITS CONTENT, AND ANY SERVICES OR ITEMS
                        FOUND OR
                        ATTAINED THROUGH THE SERVICE IS AT YOUR OWN RISK. THE SERVICE, ITS CONTENT, AND ANY SERVICES OR
                        ITEMS FOUND
                        OR ATTAINED THROUGH THE SERVICE ARE PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS, WITHOUT ANY
                        WARRANTIES
                        OF ANY KIND, EITHER EXPRESS OR IMPLIED INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
                        MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT. THE FOREGOING DOES NOT
                        AFFECT ANY
                        WARRANTIES THAT CANNOT BE EXCLUDED OR LIMITED UNDER APPLICABLE LAW.
                    </li>
                    <li>
                        NEITHER AIO NOR ITS DIRECTORS, OFFICERS, EMPLOYEES, AGENTS, SERVICE PROVIDERS, CONTRACTORS,
                        LICENSORS,
                        LICENSEES, SUPPLIERS OR SUCCESSORS MAKE ANY WARRANTY, REPRESENTATION OR ENDORSEMENT WITH RESPECT
                        TO THE
                        COMPLETENESS, SECURITY, RELIABILITY, SUITABILITY, ACCURACY, CURRENCY OR AVAILABILITY OF THE
                        SERVICE OR ITS
                        CONTENTS. WITHOUT LIMITING THE FOREGOING, NEITHER AIO NOR ITS DIRECTORS, OFFICERS, EMPLOYEES,
                        AGENTS, SERVICE
                        PROVIDERS, CONTRACTORS, LICENSORS, LICENSEES, SUPPLIERS OR SUCCESSORS REPRESENT OR WARRANT THAT
                        THE SERVICE,
                        ITS CONTENT, OR ANY SERVICES OR ITEMS FOUND OR ATTAINED THROUGH THE SERVICE WILL BE ACCURATE,
                        RELIABLE,
                        ERROR-FREE, OR UNINTERRUPTED, THAT DEFECTS WILL BE CORRECTED, THAT OUR SERVICE OR THE SERVER
                        THAT MAKES IT
                        AVAILABLE ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.
                    </li>
                    <li>
                        WE CANNOT AND DO NOT GUARANTEE OR WARRANT THAT FILES OR DATA AVAILABLE FOR DOWNLOADING FROM THE
                        INTERNET, A
                        THIRD PARTY MOBILE APPLICATION STORE (INCLUDING THE APP STORE AND GOOGLE PLAY) OR THE SERVICE
                        WILL BE FREE
                        OF VIRUSES OR OTHER DESTRUCTIVE CODE. YOU ARE SOLELY AND ENTIRELY RESPONSIBLE FOR YOUR USE OF
                        THE SERVICE AND
                        YOUR COMPUTER, INTERNET AND DATA SECURITY. TO THE FULLEST EXTENT PROVIDED BY LAW, WE WILL NOT BE
                        LIABLE FOR
                        ANY LOSS OR DAMAGE CAUSED BY DENIAL-OF-SERVICE ATTACK, DISTRIBUTED DENIAL-OF-SERVICE ATTACK,
                        OVERLOADING,
                        FLOODING, MAILBOMBING OR CRASHING, VIRUSES, TROJAN HORSES, WORMS, LOGIC BOMBS, OR OTHER
                        TECHNOLOGICALLY
                        HARMFUL CONTENT THAT MAY INFECT YOUR COMPUTER EQUIPMENT, COMPUTER PROGRAMS, DATA, OR OTHER
                        PROPRIETARY
                        CONTENT DUE TO YOUR USE OF THE SERVICE OR ANY SERVICES OR ITEMS FOUND OR ATTAINED THROUGH THE
                        SERVICE OR TO
                        YOUR DOWNLOADING OF ANY CONTENT POSTED ON IT, OR ON ANY WEBSITE LINKED TO IT.
                    </li>
                </ul>
                <li>Limitation on Liability</li>
                <ul>
                    <li>
                        EXCEPT WHERE SUCH EXCLUSIONS ARE PROHIBITED BY LAW, UNDER NO CIRCUMSTANCE WILL AIO NOR ITS
                        DIRECTORS,
                        OFFICERS, EMPLOYEES, AGENTS, SERVICE PROVIDERS, CONTRACTORS, LICENSORS, LICENSEES, SUPPLIERS, OR
                        SUCCESSORS BE LIABLE FOR NEGLIGENCE, GROSS NEGLIGENCE, NEGLIGENT MISREPRESENTATION, FUNDAMENTAL
                        BREACH,
                        DAMAGES OF ANY KIND, UNDER ANY LEGAL THEORY, INCLUDING ANY DIRECT, INDIRECT, SPECIAL,
                        INCIDENTAL,
                        CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING, BUT NOT LIMITED TO, PERSONAL INJURY, PAIN AND
                        SUFFERING,
                        EMOTIONAL DISTRESS, LOSS OF REVENUE, LOSS OF PROFITS, LOSS OF BUSINESS OR ANTICIPATED SAVINGS,
                        LOSS OF USE,
                        LOSS OF GOODWILL, LOSS OF DATA, AND WHETHER CAUSED BY TORT (INCLUDING NEGLIGENCE), BREACH OF
                        CONTRACT,
                        BREACH OF PRIVACY OR OTHERWISE, EVEN IF THE PARTY WAS ALLEGEDLY ADVISED OR HAD REASON TO KNOW,
                        ARISING OUT
                        OF OR IN CONNECTION WITH YOUR USE, OR INABILITY TO USE, OR RELIANCE ON, THE SERVICE, ANY LINKED
                        WEBSITES OR
                        SUCH OTHER THIRD-PARTY WEBSITES, NOR ANY CONTENT, MATERIALS, POSTING OR INFORMATION THEREON EVEN
                        IF THE
                        PARTY WAS ALLEGEDLY ADVISED OR HAD REASON TO KNOW.
                    </li>
                    <li>
                        If, notwithstanding the previous paragraph, we are found liable to you, under no circumstances
                        shall our
                        aggregate liability to you for any and all claims arising from your use of the Service exceed
                        the greater of
                        the total amounts you paid to us in the 12 months prior to the action giving rise to liability,
                        and (b) One
                        Hundred United States Dollars ($100.00 USD.)
                    </li>
                </ul>

                <li>Indemnification</li>
                <ul>
                    <li>
                        To the maximum extent permitted by applicable law, you agree to defend, indemnify, and hold
                        harmless AIOHub
                        and its directors, officers, employees, agents, service providers, contractors, licensors,
                        suppliers,
                        successors, and assigns from and against any claims, liabilities, damages, judgments, awards,
                        losses, costs,
                        expenses, or fees (including reasonable attorneys' fees) arising out of or relating to your
                        breach of these
                        Terms or your use of the Service, including, but not limited to, your User Content, third-party
                        sites, any
                        use of the Service's content, services, and products other than as expressly authorized in these
                        Terms.
                    </li>
                </ul>

                <li>Dispute Resolution and Arbitration</li>
                <ul>
                    <li>
                        Except to the extent prohibited by applicable law, in the event of any controversy, claim,
                        action or dispute
                        arising out of or related to any transaction conducted on the Sites, or the breach, enforcement,
                        interpretation, or validity of these Terms or any part of it ("Dispute"), the party asserting
                        the Dispute
                        shall first try in good faith to settle such Dispute by providing written notice to the other
                        party
                        describing the facts and circumstances (including any relevant documentation) of the Dispute and
                        allowing
                        the receiving party 30 days in which to respond to or settle the Dispute. Notice shall be sent
                        to us at the
                        email address specified below and to you at the email address associated with your account. To
                        the maximum
                        extent permitted by law, both you and AIOHub agree that this dispute resolution procedure is a
                        condition
                        precedent which must be satisfied prior to initiating any arbitration against the other party.
                    </li>
                    <li>
                        If you and AIOHub are unable to resolve the Dispute, the Dispute shall be determined exclusively
                        by binding
                        arbitration.
                    </li>
                    <li>
                        The arbitration shall be conducted in the state of Delaware by a single arbitrator jointly
                        selected by the
                        parties. The parties shall be responsible for their own legal costs and shall share the costs of
                        the
                        arbitration equally, subject to an award of the arbitrator to the contrary.
                    </li>
                </ul>

                <li>Governing Law and Jurisdiction</li>
                <ul>
                    <li>
                        These Terms shall be construed in accordance with and governed by the laws of the State of
                        Delaware and the
                        federal laws of United States of America applicable therein without regard to any conflict of
                        law provisions
                        and notwithstanding your domicile, residence or physical location.
                    </li>
                    <li>
                        Subject to the dispute resolution and arbitration provision, the parties irrevocably submit to
                        the exclusive
                        jurisdiction of the courts of the State of Delaware in any action or proceeding which may arise
                        out of, or
                        in connection with, the Service these Terms. You agree not to commence any such action or
                        proceeding except
                        in Delaware, United States.
                    </li>
                </ul>

                <li>General</li>
                <ul style={{marginBottom:50}}>
                    <li>
                        For residents of Quebec, Canada, the parties acknowledge that they have required that these
                        Terms and all
                        related documents be prepared in English. Les parties reconnaissent avoir exigé que la présente
                        convention
                        et tous les documents connexes soient rédigés en anglais.
                    </li>
                </ul>
            </ul>


        </div>
    );
};

export default TermsOfService;
